module.exports = __webpack_public_path__ + "img/quick-start-guide_in.d98a6afc.jpg";